/**
 * 会员信息
 */
import React, { Component } from 'react';

import { Modal, Input, Row, Col, DatePicker, Icon, Tooltip, Form, Button } from 'antd';
import PageLayout from '../../ui/PageLayout';
import DictSelect from '../../ui/DictSelect';
import messager from '../../ui/messager';
import http from '../../../axios/http';
import Loading from '../../ui/Loading';
import FinancialAuditDetail from "./FinancialAuditDetail";
import { global_data } from '../../ui/auth'
import FinancialAuditEdit from "./FinancialAuditEdit";

class FinancialAuditIndex extends React.Component {

    columns = [{
        title: '充值类型',
        dataIndex: 'type',
        width: '8%'
    }
    ,{
        title: '金额(元)',
        dataIndex: 'amount',
        width: '5%',
    }
    ,{
        title: '交款人',
        dataIndex: 'name',
        width: '12%',
    }
    ,{
        title: '会员类型',
        dataIndex: 'index',
        width: '15%',
        render: (text, record, index) => {
            let t = "";
            t += record.tenant === 1 ? '租户' : '';
            if (record.agent === 1) {
                t += (t !== "" ? "/代办" : "代办");
            }
            if (record.mall === 1) {
                t += (t !== "" ? "/商城会员" : "商城会员");
            }
            if (record.auction === 1) {
                t += (t !== "" ? "/竞价会员" : "竞价会员");
            }
            return (
                <div>
                    <Tooltip title={t}>
                        <span>{t}</span>
                    </Tooltip>
                </div>
            )
        }
    }, {
        title: '操作人',
        dataIndex: 'creator',
        width: '6%',
    }, {
        title: '操作时间',
        dataIndex: 'insertTime',
        width: '10%',
    }, {
        title: '备注',
        dataIndex: 'remark',
        width: '10%',
    }, {
        title: '审核备注',
        dataIndex: 'auditMind',
        width: '10%',
    }, {
        title: '审核状态',
        dataIndex: 'status',
        width: '8%',
        render: (text, record, index) => {
            let statusMap = { 0: "待审核", 1: "审核通过", 2: "审核不通过" };
            return statusMap[text];
        }
    }, {
        title: '操作',
        dataIndex: 'id',
        width: '10%',
        render: (text, record, index) => (
            <div>
                {global_data.authCode.includes("FINANCIAL_AUDIT_ACCEPT")&&record.status === 0 ? 
                <Tooltip title="审核通过">
                    <Icon type="check-circle" theme="filled" className="table-operate-icon" onClick={this.enable.bind(this, record.id)} />
                </Tooltip> 
                : ""}
                {global_data.authCode.includes("FINANCIAL_AUDIT_REFUSE")&&record.status === 0 ? 
                <Tooltip title="审核不通过">
                    <Icon type="stop" theme="filled" className="table-operate-icon" onClick={this.disable.bind(this, record.id)} />
                </Tooltip> 
                : ""}
                <Tooltip title="详情">
                    <Icon type="eye" theme="filled" className="table-operate-icon" onClick={this.detail.bind(this, record.id)} />
                </Tooltip>
                {global_data.authCode.includes("FINANCIAL_AUDIT_EDIT")?
                    <Tooltip title="修改备注">
                        <Icon type="edit" theme="filled" className="table-operate-icon" onClick={this.edit.bind(this, record.id)} />
                    </Tooltip>
                    : ""}
            </div>
        )
    }];

    state = {
        detailVisible: false,
        editVisible: false,
        loadData: '',
        queryData: {},
        editData: {},
        auditMindVisible: false,
        auditMindType: "success",
        auditMindText: "审核通过",

        
        loadingVisible: false    //导出遮罩
    };

    //详情
    detail = (id, e) => {
        http.get({
            url: '/financial/audit/query/detail',
            data: { id: id },
            success: (res) => {
                this.setState({ detailVisible: true, editData: res });
            },
            error: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
    }

    edit = (id,e) => {
        http.get({
            url: '/financial/audit/query/detail',
            data: { id: id },
            success: (res) => {
                this.setState({ editVisible: true, editData: res });
            },
            error: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
    }

    //审核成功
    enable = (info, e) => {
        this.setState({
            auditMindVisible: true,
            auditMindType: "success",
            auditMindText: "审核通过",
            dataId: info
        })
    }

    //审核不通过
    disable = (info, e) => {
        this.setState({
            auditMindVisible: true,
            auditMindType: "fail",
            auditMindText: "审核不通过",
            dataId: info
        })
    }

    hiddenAuditModal = () => {
        this.setState({ auditMindVisible: false, dataId: 0 });
    }

    doAuctionSuccess = () => {
        messager.notify("审核成功！");
        this.state.loadData();
    }

    //导出数据
    download = () => {
        let queryData = this.state.queryData;
        if (queryData.startDate == null || queryData.startDate === "") {
            messager.notify("请选择时间段进行导出！");
            return;
        }
        this.setState({ loadingVisible: true });
        queryData.pageNumber = 1;
        queryData.pageSize = 5000;
        http.download({
            url: '/financial/audit/download',
            data: queryData,
            fileName: "充值审核记录.xlsx",
            success: (res) => {
                this.setState({ loadingVisible: false });
            },
            error: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
    }

    inputSearch = (field, value) => {
        let queryData = this.state.queryData;
        queryData[field] = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData)
    }

    rangePickerChange = (dates, dateStrings) => {
        let queryData = this.state.queryData;
        queryData.startDate = dateStrings[0];
        queryData.endDate = dateStrings[1];
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    selectChange = (value) => {
        let { queryData } = this.state;
        queryData["type"] = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={20}>
                                <Input.Search
                                    placeholder="交款人"
                                    onSearch={this.inputSearch.bind(this, "name")}
                                    enterButton
                                    style={{ width: 250, marginLeft: '10px', marginRight: '10px' }}
                                />
                                <DatePicker.RangePicker onChange={this.rangePickerChange} />
                                <DictSelect category="FINANCIAL_AUDIT_TYPE" allowClear={true} onChange={this.selectChange} style={{ width: '150px', margin: '0 10px' }} />
                            </Col>
                            <Col span={4} style={{ textAlign: "right" }}>
                                <Button type="primary" onClick={this.download}>导出</Button>
                            </Col>
                        </Row>
                    )}
                    rowKey="id" url="/financial/audit/query/page" requestType="get" columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <FinancialAuditDetail
                    visible={this.state.detailVisible}
                    onCancel={() => { this.setState({ detailVisible: false, editData: {} }) }}
                    editData={this.state.editData}
                />
                <AuditMind
                    visible={this.state.auditMindVisible}
                    onCancel={this.hiddenAuditModal.bind(this)}
                    dataId={this.state.dataId}
                    successCallback={this.doAuctionSuccess}
                    type={this.state.auditMindType}
                    text={this.state.auditMindText}
                />
                <FinancialAuditEdit
                    visible={this.state.editVisible}
                    onCancel={() => { this.setState({ editVisible: false, editData: {} }) }}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                />
                 <Loading visible={this.state.loadingVisible} message="正在导出，请稍候..." />
            </div>
        )
    }
}

class AuditMindForm extends Component {

    audit = () => {
        const { form, type } = this.props;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            values["id"] = this.props.dataId;
            http.post({
                url: "/financial/audit/" + type,
                data: values,
                success: (res) => {
                    this.props.onCancel();
                    this.props.successCallback();
                }
            });
        });
    }

    render() {
        const { visible, onCancel, form, text } = this.props;
        const { getFieldDecorator } = form;
        return (
            <Modal
                visible={visible}
                title={text}
                okText="确定"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.audit}
                zIndex={1001}
                afterClose={() => { this.props.form.resetFields() }}
            >
                <Form layout="vertical" labelCol={{ span: 5 }} wrapperCol={{ span: 19 }}>
                    <Form.Item label={"备注："}>
                        {getFieldDecorator('auditMind', {
                            rules: [
                                { max: 256, message: '最多只能输入256个字符！' }],
                        })(
                            <Input.TextArea />
                        )}
                    </Form.Item>
                </Form>
            </Modal>
        );
    }
}

const AuditMind = Form.create()(AuditMindForm);

export default FinancialAuditIndex;